import PageLoadedQueue
    from "../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";
import {Modal} from "bootstrap";

export class ExpertDetailForm {
    protected form: HTMLFormElement;

    protected fieldsWrapper: HTMLDivElement;

    protected submitButton: HTMLButtonElement;

    protected modal: Modal = undefined;

    protected modalAlert: HTMLDivElement = undefined;

    constructor(form: HTMLFormElement) {
        this.form = form;

        if (!form) {
            return;
        }

        this.fieldsWrapper = form.querySelector('#update-form-profile-questions--fields') as HTMLDivElement;
        this.submitButton = form.querySelector('#update-form-profile-questions--submit-button') as HTMLButtonElement;

        const modalEl = document.getElementById('update-form-profile-question--modal') as HTMLElement;
        if (modalEl) {
            this.modal = Modal.getOrCreateInstance(modalEl);
            this.modalAlert = modalEl.querySelector('#update-form-profile-question--modal-alert') as HTMLDivElement;
        }

        this.submitButton.addEventListener('click', this.submit.bind(this));
    }

    protected async submit(event: Event) {
        event.preventDefault();
        const formData = new FormData(this.form);

        const response = await fetch(this.form.action, {
            method: 'POST',
            body: formData
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.success) {
                    const uri = new URL(this.form.dataset.profileUri, window.location.href);
                    window.location = uri.href;

                    return;
                }

                throw new Error(data.message + '\n\nError-Code: ' + data.code);
            })

            .catch((error) => {
                if (this.modal) {
                    this.modalAlert.classList.remove('d-none');
                    this.modalAlert.innerText = error.message;
                    this.modal.show();
                }
                console.error('Error:', error);
            });
    }
}

PageLoadedQueue.addFunction(() => {
    const form = document.getElementById('solutions-experts-profile-edit-questions-form') as HTMLFormElement;

    if (form) {
        const expertDetailForm = new ExpertDetailForm(form);
    }
});
